import { fabric } from 'fabric';

import { setActiveShapeNameAndColors } from './setActiveShapeNameAndColors';
import { setGroupColors } from './setGroupColors';
import { setItemNameAndColors } from './setItemNameAndColors';

import { DrawingShape } from '~/core/models';
import { isShapeGroup } from '~/core/utils';

export const setShapeNameAndColors = (
  canvas: fabric.Canvas,
  color: string,
  activeDrawingShape?: DrawingShape
) => {
  canvas.getObjects().forEach((canvasObject) => {
    if (isShapeGroup(canvasObject)) {
      const objectsInGroup = (canvasObject as fabric.Group)
        .getObjects()
        .filter((obj) => obj.data && obj.data.highlightable);

      objectsInGroup.forEach((item) => {
        if ((item as fabric.Group).getObjects) {
          setGroupColors(item as fabric.Group, color, activeDrawingShape);
        } else if (item.data?.inInterior) {
          item.set({ stroke: color });
          item.set({ fill: color });
        } else if (
          item.data.parentName === activeDrawingShape?.canvasObjectName
        ) {
          setActiveShapeNameAndColors(item);
        } else {
          setItemNameAndColors(item);
        }
      });
    }
  });
};
